export const colors = {
    accents_gradient_start: "#FFD881",
    accents_grass: "#8DBD64",
    accents_lilac: "#A475DD",
    accents_salmon: "#FF9378",
    accents_sky: "#2C88D8",
    accents_sun: "#FFD881",
    accents_sunset: "#FF8A2D",
    black_12: "#0714201F",
    black_30: "#0714204D",
    black_4: "#0D07000A",
    black_8: "#07142014",
    black_light: "#2D3A47",
    black_lighter: "#636A70",
    black_main: "#071420",
    chips_amethyst: "#7349A7",
    chips_azure: "#0F4B81",
    chips_cherry: "#A82200",
    chips_ember: "#BD5500",
    chips_forest: "#477E35",
    chips_neptune: "#2478C2",
    chips_redwood: "#803900",
    chips_saffron: "#996900",
    chips_slate: "#636A70",
    chips_tulip: "#DF280C",
    forest_12: "#477E351F",
    forest_30: "#477E354D",
    forest_4: "#477E350A",
    forest_50: "#477E3580",
    forest_8: "#477E3514",
    forest_dark: "#3B682C",
    forest_light: "#5DA545",
    forest_main: "#477E35",
    navy_12: "#0D27401F",
    navy_30: "#0D27404D",
    navy_4: "#0D27400A",
    navy_50: "#0D274080",
    navy_8: "#0D274014",
    navy_dark: "#071420",
    navy_light: "#0D375F",
    navy_main: "#0D2740",
    sunset_12: "#FF8A2D1F",
    sunset_30: "#FF8A2D4D",
    sunset_4: "#FF8A2D0A",
    sunset_50: "#FF8A2D80",
    sunset_8: "#FF8A2D14",
    sunset_dark: "#FF7406",
    sunset_light: "#FFA965",
    sunset_main: "#FF8A2D",
    tulip_12: "#DF280C1F",
    tulip_30: "#DF280C4D",
    tulip_4: "#DF280C0A",
    tulip_50: "#DF280C80",
    tulip_8: "#DF280C14",
    tulip_dark: "#BD220A",
    tulip_light: "#F44B32",
    tulip_main: "#DF280C",
    white_background: "#FAFAFA",
    white_main: "#FFFFFF",
    black: "#000",
    action_light: "#0000008a",
    blue_5: "#1D62AE0D",
    blue_10: "#1D62AE1A",
    blue_30: "#1D62AE4D",
    blue_50: "#1D62AE80",
    blue_main: "#1D62AE",
    accents_lilac_8: "#A475DD14",
    accents_sun_8: "#FFD88114",
    accents_sunset_12: "#ff8a2d1f",
    accents_sunset_25: "#ff8a2d40",
    accents_sunset_background: "#ffe5d0",
    orange_8: "#FF870014",
    chips_forest_8: "#477E3514",
    navy_30_opaque: "#b5bec5",
    navy_50_opaque: "#86939F",
    black_12_opaque: "#E1E2E4",
    white_background_gradient_start: "#FAFAFA00",
};
